import Marquee from "react-fast-marquee";
import { Reveal, Overline } from "@/components/Reveal";

const items = [
  { label: "Atendimento", desc: "Triagem, respostas, follow-up, atualização de informações e encaminhamentos." },
  { label: "Comercial", desc: "Qualificação, distribuição de leads, follow-up e atualização de CRM." },
  { label: "Backoffice", desc: "Cadastro, conferência, transferência e organização de informações." },
  { label: "Financeiro", desc: "Cobranças, conciliações, geração e organização de informações financeiras." },
  { label: "Integrações", desc: "Conexão entre sistemas, APIs, bancos de dados, planilhas e ferramentas." },
  { label: "Processamento de dados", desc: "Leitura, transformação, validação e distribuição de dados." },
  { label: "Sistemas internos", desc: "Automação de tarefas e fluxos específicos da operação." },
  { label: "Softwares legados", desc: "Integração e execução assistida em sistemas antigos ou sem API." },
  { label: "Operações administrativas", desc: "Tarefas repetitivas, documentos, registros e controles." },
  { label: "Processos personalizados", desc: "Automações desenvolvidas especificamente para uma operação." },
];

// bento spans for a technical wireframe grid
const spans = [
  "md:col-span-2 md:row-span-2",
  "md:col-span-1",
  "md:col-span-1",
  "md:col-span-1",
  "md:col-span-2",
  "md:col-span-1",
  "md:col-span-1",
  "md:col-span-2",
  "md:col-span-1",
  "md:col-span-1",
];

export const Capabilities = () => {
  return (
    <section id="capabilities" className="relative py-28 md:py-40 border-t border-white/5">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Reveal>
          <Overline>Escopo</Overline>
          <h2 className="font-display font-extrabold text-3xl md:text-5xl tracking-tight leading-[1.05] mt-6 max-w-[20ch]">
            O que podemos automatizar
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-14 grid grid-cols-1 md:grid-cols-4 gap-[1px] bg-white/10 border border-white/10 rounded-sm overflow-hidden auto-rows-[minmax(120px,auto)]">
            {items.map((item, i) => (
              <div
                key={i}
                className={`group relative bg-[#0a0a0a] p-6 md:p-8 flex flex-col gap-6 justify-between hover:bg-[#101010] transition-colors ${spans[i]}`}
              >
                <span className="font-mono text-[11px] text-neutral-600">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <span className="block font-display font-bold text-xl md:text-2xl tracking-tight text-neutral-200 group-hover:text-white transition-colors">
                    {item.label}
                  </span>
                  <p className="mt-2 text-sm leading-relaxed text-neutral-500">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>

      {/* slow editorial marquee band */}
      <div className="mt-24 border-y border-white/5 py-8 select-none">
        <Marquee speed={26} gradient={false} autoFill>
          {[
            "WhatsApp",
            "CRM",
            "ERP",
            "Planilhas",
            "E-mail",
            "APIs",
            "Bancos de dados",
            "Sistemas legados",
          ].map((w, i) => (
            <span
              key={i}
              className="mx-8 font-display font-extrabold text-4xl md:text-6xl tracking-tighter text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.18)]"
            >
              {w}
              <span className="text-white/20"> · </span>
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
};
